/* eslint-disable max-lines */
import { nanoid } from 'nanoid';

import CampaignLabel from 'Component/CampaignLabel';
import { IMAGE_PLACEHOLDER } from 'Component/CartItem/CartItem.config';
import CartItemPrice from 'Component/CartItemPrice';
import DeleteIcon from 'Component/DeleteIcon';
import ExpandableContent from 'Component/ExpandableContent';
import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Image from 'Component/Image';
import Link from 'Component/Link';
import Loader from 'Component/Loader';
import {
    CartItem as SourceCartItem
} from 'SourceComponent/CartItem/CartItem.component';
import {
    getPrice
} from 'Util/Product/Extract';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

import WarningIconComponent from '../WarningIcon';

import './CartItem.style';

/** @namespace Bodypwa/Component/CartItem/Component */
export class CartItemComponent extends SourceCartItem {
    state = {
        isContentExpanded: false
    };

    toggleExpandableContent = () => {
        this.setState(({ isContentExpanded }) => ({ isContentExpanded: !isContentExpanded }));
    };

    renderOutOfStockMessage() {
        const { isProductInStock } = this.props;

        if (isProductInStock) {
            return null;
        }

        return (
            <p block="CartItem" elem="OutOfStock">
                <WarningIconComponent />
                { __('Product is out of stock') }
            </p>
        );
    }

    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    quantityClickHandler() {
    }

    renderProductConfigurations() {
        const {
            optionsLabels, isMobile, isMobileLayout
        } = this.props;
        const { isContentExpanded } = this.state;
        const heading = isContentExpanded ? __('Hide details') : __('See details');

        if (!optionsLabels.length) {
            return null;
        }

        if (isMobile || isMobileLayout) {
            return (
                <ExpandableContent
                  heading={ heading }
                  mix={ { block: 'CartItem', elem: 'OptionsExpandable' } }
                  isContentExpanded={ isContentExpanded }
                  onClick={ this.toggleExpandableContent }
                  isArrow
                >
                    <ul
                      block="CartItem"
                      elem="Options"
                    >
                        { optionsLabels.map((option) => (
                            <li key={ nanoid() }>{ option }</li>
                        )) }
                    </ul>
                </ExpandableContent>
            );
        }

        return (
            <ol
              block="CartItem"
              elem="Options"
            >
                { optionsLabels.map((option) => (
                    <li key={ nanoid() }>{ option }</li>
                )) }
            </ol>
        );
    }

    renderTitle() {
        const { isMobileLayout } = this.props;

        const {
            item: {
                customizable_options,
                bundle_options,
                downloadable_links,
                product: {
                    attributes
                }
            } = {},
            linkTo
        } = this.props;

        const {
            brand_name
        } = attributes || {};
        const brand = !brand_name || brand_name.attribute_options[brand_name.attribute_value].label;

        return (
            <div block="CartItem" elem="Title" mods={ { isMobileLayout } }>
                <span
                  block="CartItem"
                  elem="Brand"
                >
                    { brand }
                </span>
                <Link to={ linkTo }>
                    { this.renderProductName() }
                </Link>
                { this.renderOutOfStockMessage() }
                { this.renderProductConfigurations() }
                { this.renderProductOptions(customizable_options) }
                { this.renderProductBundleOptions(bundle_options) }
                { this.renderProductLinks(downloadable_links) }
            </div>
        );
    }

    renderContent() {
        return (
            <span block="CartItem" elem="Link">
                    { this.renderWrapperContent() }
            </span>
        );
    }

    renderImage() {
        const { linkTo } = this.props;

        return (
            <div>
                <Link to={ linkTo } block="CartItem" elem="Link">
                    { this.renderImageElement() }
                </Link>
            </div>
        );
    }

    renderImageElement() {
        const {
            item: {
                product: { name, thumbnail: { url: thumbnailBase, overlay_disable } },
                discount_amount,
                product
            },
            thumbnail,
            isProductInStock,
            isMobileLayout
        } = this.props;

        const isNotAvailable = !isProductInStock;
        return (
            <div>
                <Image
                  src={ thumbnail.includes(IMAGE_PLACEHOLDER) ? thumbnailBase : thumbnail }
                  mix={ {
                      block: 'CartItem',
                      elem: 'Picture',
                      mods: {
                          isNotAvailable, isMobileLayout, overlayDisabe: !!+overlay_disable
                      }
                  } }
                  ratio="custom"
                  alt={ `Product ${name} thumbnail.` }
                />
                <img
                  style={ { display: 'none' } }
                  alt={ name }
                  src={ thumbnail.includes(IMAGE_PLACEHOLDER) ? thumbnailBase : thumbnail }
                  loading="lazy"
                />
                <CampaignLabel discount={ discount_amount } product={ product } isCampaingLabel isBottom />
            </div>
        );
    }

    renderDesktopSummary() {
        return (
            <div block="CartItem" elem="Wrapper" mods={ { isSummary: true } }>
                { this.renderImage() }
                <div block="CartItem" elem="CartItemRows">
                    <div block="CartItem" elem="ProductInfo">
                        { this.renderTitle() }
                        { this.renderProductPrice() }
                    </div>
                    <div block="CartItem" elem="ProductActions">
                        { this.renderQuantity() }
                    </div>
                </div>
            </div>
        );
    }

    renderProductPrice() {
        const {
            currency_code,
            item: {
                row_total,
                row_total_incl_tax,
                product: {
                    price_range: priceRange,
                    type_id
                },
                qty
            },
            isCartOverlay,
            isMobileLayout
        } = this.props;

        const dynamicPrice = false;

        const {
            price: {
                discount: { percentOff },
                originalPrice
            }
        } = getPrice(priceRange, dynamicPrice, {}, type_id, []);

        return (
            <div block="ProductPrice" elem="Container">
                <CartItemPrice
                  regular_price={ originalPrice }
                  row_total={ row_total }
                  row_total_incl_tax={ row_total_incl_tax }
                  currency_code={ currency_code }
                  percentOff={ percentOff }
                  qty={ qty }
                  mix={ {
                      block: 'CartItem',
                      elem: 'Price',
                      mods: { isCartOverlay, isMobileLayout }
                  } }
                />
                <CampaignLabel discount={ percentOff } isCampaingLabel={ false } />
            </div>
        );
    }

    renderDeleteButton() {
        const { handleRemoveItem, isMobileLayout } = this.props;

        return (
            <button
              block="CartItem"
              id="RemoveItem"
              name="RemoveItem"
              elem="Delete"
              mods={ { isMobileLayout } }
              aria-label="Remove item from cart"
              onClick={ handleRemoveItem }
            >
                <DeleteIcon />
                <span block="CartItem" elem="DeleteButtonText">
                    { __('Delete') }
                </span>
            </button>
        );
    }

    renderLoader() {
        const { showLoader, loading } = this.props;

        if (!showLoader) {
            return false;
        }

        return (
            <Loader isLoading={ loading } />
        );
    }

    renderDesktopContent() {
        return (
            <div block="CartItem" elem="Wrapper" mods={ { isCart: true } }>
                <div block="CartItem" elem="ProductInfo">
                    { this.renderImage() }
                    { this.renderTitle() }
                </div>
                <div
                  block="CartItem"
                  elem="ProductQty"
                >
                    { this.renderQuantityChangeField() }
                </div>
                <div
                  block="CartItem"
                  elem="ProductActions"
                >
                    { this.renderProductPrice() }
                    { this.renderDeleteButton() }
                </div>
            </div>
        );
    }

    renderQuantityChangeField() {
        const {
            item: {
                sku,
                qty,
                product: {
                    stock_item: {
                        qty_increments: qtyIncrement = 1
                    } = {}
                } = {}
            } = {},
            maxSaleQuantity,
            handleChangeQuantity,
            handleInputChangeQuantity,
            handleInputBlur,
            isProductInStock,
            isCartOverlay
        } = this.props;

        if (!isProductInStock) {
            return <div block="CartItem" elem="QuantityWrapper" mods={ { isPlaceholder: true } } />;
        }

        return (
            <div
              block="CartItem"
              elem="QuantityWrapper"
              mods={ { isCartOverlay } }
              onClick={ this.quantityClickHandler }
              onKeyDown={ this.quantityClickHandler }
              role="button"
              tabIndex="-1"
            >
                <Field
                  id="item_qty"
                  type={ FIELD_TYPE.number }
                  attr={ {
                      id: `${sku}_item_qty`,
                      name: `${sku}_item_qty`,
                      value: qty,
                      defaultValue: qty,
                      min: 0,
                      max: maxSaleQuantity,
                      step: qtyIncrement
                  } }
                  events={ {
                      onChange: handleChangeQuantity,
                      onBlur: handleInputBlur,
                      onInputChange: handleInputChangeQuantity
                  } }
                  validationRule={ {
                      inputType: VALIDATION_INPUT_TYPE.numeric,
                      range: {
                          min: 0,
                          max: maxSaleQuantity
                      }
                  } }
                  validateOn={ ['onChange'] }
                  mix={ { block: 'CartItem', elem: 'Qty' } }
                />
            </div>
        );
    }

    render() {
        const { isEditing, isCartOverlay } = this.props;

        return (
            <div
              block="CartItem"
              mods={ { isEditing, isCartOverlay } }
            >
                { this.renderContent() }
            </div>
        );
    }
}

export default CartItemComponent;
